import { Routes } from '@angular/router';
import { AppRoutes } from './shared/enums/app-routes.enum';
import { xpoAuthCanActivate, xpoAuthCanActivateChild } from '@xpo-ltl/ngx-auth';

export const appRoutes: Routes = [
  {
    path: AppRoutes.API_STORE,
    data: { breadcrumb: 'API Store' },
    loadChildren: () => import('./api-store/api-store.routes').then((m) => m.apiStoreRoutes),
    // canActivate blocks the navigation while the sign-in redirect is pending; a canMatch guard
    // would fall through to the '**' not-found route instead.
    canActivate: [xpoAuthCanActivate()],
    canActivateChild: [xpoAuthCanActivateChild()],
  },
  {
    path: '',
    redirectTo: AppRoutes.API_STORE,
    pathMatch: 'full',
  },
];
